import { render } from "./NotificationInApp.vue?vue&type=template&id=c53350c6&scoped=true"
import script from "./NotificationInApp.vue?vue&type=script&lang=js"
export * from "./NotificationInApp.vue?vue&type=script&lang=js"

import "./NotificationInApp.vue?vue&type=style&index=0&id=c53350c6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53350c6"]])

export default __exports__